<div class="grid-container">
  <app-grid (gridEvents)="onEvent($event)" [columns]="columns"
            [filter]="true"
            [store]="gridStore"
            [width]="'calc(100vw)'"
  ></app-grid>
</div>
<mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
               [pageSizeOptions]="pageSizeOptions"
               [pageSize]="gridStore.pageSize"
               hidePageSize="false"
               showFirstLastButtons="true">
</mat-paginator>
